const ONE_DAY_MS = 24 * 60 * 60 * 1000;

// Compact relative-time formatter. Mirrors the convention used in
// apps/portal/src/feedback/forum-post-card.tsx so the insights surface
// reads the same as the inbox.
export function relativeTime(timestamp: string): string {
  const date = new Date(timestamp);
  const diff = Date.now() - date.getTime();
  if (diff < 60_000) return 'just now';
  if (diff < ONE_DAY_MS) {
    const minutes = Math.floor(diff / 60_000);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    return `${hours}h ago`;
  }
  const days = Math.floor(diff / ONE_DAY_MS);
  if (days < 30) return `${days}d ago`;
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

// Minutes-remaining formatter used by the Refresh cooldown surface.
// "Available in Xm" / "Available in <1m".
export function formatCooldownRemaining(remainingMs: number): string {
  if (remainingMs <= 0) return 'available now';
  const minutes = Math.ceil(remainingMs / 60_000);
  if (minutes < 1) return 'available in <1m';
  return `available in ${minutes}m`;
}
